<template>
  <div class="topdiv ztop ytopdiv fs0">
    <div class="htmldiv tbg pb20">
      <router-link to="/dedu/index">
        <img src="../../assets/images/index_01_05.png" />
      </router-link>
      <div class="rdiv fr tright mt30">
        <div class="searchdiv mt20 prelative">
          <div class="pinput br5 prelative ofhidden dinline-block bgw tleft">
            <input class="input dinline-block" name="" placeholder="请输入关键字搜索" v-model="keyword">
            <a class="zbtn pabsolute trans3" href="javascript:void(0);" @click="search"></a>

          </div>
        </div>
      </div>
    </div>
    <div class="nav fs0 bg-m">
      <div class="htmldiv">
        <router-link to="/" class="sa trans3 fs18 mr40 dinline-block twhite">学院总站</router-link>
        <router-link to="/dedu/index" class="trans3 fs18 dinline-block twhite prelative" :class="[action=='index'?'active':'']">
          远程教育首页
          <div class="border dnone pabsolute"></div>
        </router-link>
        <router-link to="/dedu/school/detail?id=10" class="trans3 fs18 dinline-block twhite prelative" :class="[action=='school'?'active':'']">
          主办院校
          <div class="border dnone pabsolute"></div>
        </router-link>
        <router-link to="/dedu/notice/index" class="trans3 fs18 dinline-block twhite prelative" :class="[action=='notice'?'active':'']">
          公告信息
          <div class="border dnone pabsolute"></div>
        </router-link>
        <router-link to="/dedu/enrollment/index" class="trans3 fs18 dinline-block twhite prelative" :class="">
          招生资讯
          <div class="border dnone pabsolute"></div>
        </router-link>
        <router-link to="/dedu/professional/index" class="trans3 fs18 dinline-block twhite prelative" :class="[action=='professional'?'active':'']">
          报读专业
          <div class="border dnone pabsolute"></div>
        </router-link>
        <!-- <router-link to="/dedu/policy/index" class="trans3 fs18 dinline-block twhite prelative" :class="[action=='policy'?'active':'']">
          政策文件
          <div class="border dnone pabsolute"></div>
        </router-link> -->
        <router-link to="/dedu/student/index" class="trans3 fs18 dinline-block twhite prelative" :class="[action=='student'?'active':'']">
          招生简章
          <div class="border dnone pabsolute"></div>
        </router-link>
        <router-link to="/" class="trans3 fs18 dinline-block twhite prelative" :class="[action=='???'?'active':'']">
          联系我们
          <div class="border dnone pabsolute"></div>
        </router-link>　　       　　       　    　   　  　     　　       　　
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "top",
    data () {
      return {
        action : 'index',
        keyword : '',
      }
    },
    mounted() {
      $('.topdiv input').focus(function(){
        var p = $(this).parent();
        p.css('box-shadow', '0 0 5px #b0782b');
      })
      $('.topdiv input').blur(function(){
        $(this).parent().css('box-shadow', 'none');
      })
    },
    created() {
      var pathes = this.$router.currentRoute.path.split('/');
      this.action = pathes[2];
    },
    methods:{
      search:function () {
        this.$router.push({path:'/search',query:{keyword:this.keyword}})
      }
    }
  }
</script>

<style scoped>
  .topdiv .tbg{background: url(../../assets/images/index_04_01.jpg) no-repeat bottom right;}
  .bg-m a:hover{text-decoration: underline;}
  .nav a{text-align: center;}
  .ztop .nav a{line-height: 56px;}
  .ztop .nav a.active .border{display: block;}
  .ztop .border{left: 0;right: 0;bottom: 0;height: 2px;background: #ecc827;}
  .ztop .border::before{content: ''; position: absolute; border: 4px solid transparent; border-bottom-color: #ecc827; left: 0; right: 0; width: 8px; height: 8px; margin: 0 auto; top: -8px;}
  .ztop .sa{text-align: center;}
  .ytopdiv .pinput{border: 1px solid #b0782b;background: #b0782b;}
  .ytopdiv .nav{background: #b2792a;}
  .ytopdiv .nav a.active,.ytopdiv .nav a:hover{text-decoration: none;background: #da9f4e;}
  .ytopdiv .nav a{padding: 0 35px;}
  .ytopdiv .sa{margin-right: 100px;background: #da9f4e;}
  .pinput{width: 220px;height: 36px;background: #385d8c;}
  .pinput input{width: 182px;height: 36px;border: none;outline: none;}
  .pinput input:focus{box-shadow: none;}
  .pinput .zbtn{right: 0;top: 0;width: 36px;height: 36px;background:  url(../../assets/images/cn1.png) no-repeat -22px -11px;}
  .pinput .zbtn:hover{background-position: -23px -13px;}
</style>



// WEBPACK FOOTER //
// src/components/dedu/top.vue